'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { merge } from 'rxjs/observable/merge';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { FINISH_FREE_LP_ONBOARDING_TOUR } from '../actions/ActionTypes';
import { SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR, SEEN_STATE_ATTRIBUTES } from '../constants/tour';
import { requestSetAttribute, requestedSetAttributeFailure, requestedSetAttributeSuccess } from '../actions/AttributeActions';
export default ((action$, _, {
  AttributesClient
}) => action$.ofType(FINISH_FREE_LP_ONBOARDING_TOUR).pipe(mergeMap(({
  payload: {
    seenStateAttributes
  }
}) => merge(AttributesClient.setAttribute(SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR, false).pipe(map(() => requestedSetAttributeSuccess()), catchError(error => of(requestedSetAttributeFailure(error))), startWith(requestSetAttribute())), AttributesClient.setAttribute(SEEN_STATE_ATTRIBUTES, JSON.stringify(seenStateAttributes)).pipe(map(() => requestedSetAttributeSuccess()), catchError(error => of(requestedSetAttributeFailure(error))), startWith(requestSetAttribute()))))));